import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const RelevantPDFViewer = ({ signedUrl, pageNumber }) => {
  const [numPages, setNumPages] = useState(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <Document
        file={signedUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        className="border mb-2"
      >
        {pageNumber.length !== 0 &&
          pageNumber.map((page) => (
            <Page
              key={`page_${page + 1}`}
              pageNumber={page + 1}
              className="border p-2"
            />
          ))}
      </Document>
    </div>
  );
};

export default RelevantPDFViewer;
